import axios from 'axios';

const base = () => `${window.store.event_backend_api}/communications/history`;

// source/page/per_page are always sent as real query params (not baked into
// a URL string or applied after the fact) so the list request stays a single
// server-side query — see HistoryController::index.
export const listHistory = ({ source = 'all', sentBy = '', page = 1, perPage = 10 } = {}) =>
  axios
    .get(base(), { params: { source, page, per_page: perPage, ...(sentBy ? { sent_by: sentBy } : {}) } })
    .then(({ data }) => ({ data: data.data, meta: data.meta }));

export const getHistoryEntry = (id) =>
  axios.get(`${base()}/${id}`).then(({ data }) => data.data);
